import*as e from"react";import{T as o,d as r}from"./defaultTheme-7eb11447.js";import{u as s}from"./useTheme-d06521c6.js";function t(){const t=s(r);return"production"!==process.env.NODE_ENV&&e.useDebugValue(t),t[o]||t}export{t as u};
